export const INGREDIENT_GROUP_LABELS = {
    flour: 'Flour',
    dry: 'Dry ingredients',
    fresh: 'Fresh ingredients',
    liquid: 'Liquid',
    pantry: 'Pantry',
    frozen: 'Frozen goods',
    packaging: 'Package',
    utilities: 'Utilities',
    other: 'Other',
};
//# sourceMappingURL=inventory.js.map